import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { callApi } from "../../api";
import { useAuth } from "../useAuth";

const useIntegrationData = () => {
  const [domainLoading, setDomainLoading] = useState(null);
  const { selectedBusiness } = useAuth();
  const [epaySettings, setEpaySetting] = useState(null);
  const [domains, setDomains] = useState([]);
  const [stripeDashboarSettings, setStripeDashboardSettings] = useState({});

  const isRecurringEnabled = epaySettings?.epay?.recurring?.enabled;

  const isWebOrderEnabled =
    epaySettings?.epay?.weborder?.enabled &&
    epaySettings?.epay?.weborder?.provider;

  // get payroll info for payroll section.
  const getBusinessEpaySettings = async (hideToast) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/epaysettings/get`
    );
    if (res && res.status === true) {
      setEpaySetting(res.data);
      /* eslint-disable */
      console.log("Epay settings", res.data);
      if (res.data?.websites)
        setDomains(res.data?.websites?.map((el) => el.split("://")?.[1]));
    } else if (!hideToast) toast.error("Failed to fetch epay settings !");

    return res;
  };

  const getBusinessDomains = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/epaysettings/get`
    );
    if (res && res.status === true) {
      if (res.data?.websites)
        setDomains(res.data?.websites?.map((el) => el.split("://")?.[1]));
      else setDomains([]);
    }
    return res;
  };

  const updateWhitelistDomain = async (data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/domains/update`,
      "POST",
      data
    );
    setDomainLoading(null);
    if (res && res.status === true) {
      toast.success("Domains Updated Successfully!");
      setDomains(res.data?.map((el) => el.split("://")?.[1]));
      return res.data;
    }
    toast.error("Failed to update domain !");
    return null;
  };

  const updateBusinessEpaySettings = async (data, hideToast) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/epaysettings/update`,
      "POST",
      data
    );
    if (res && res.status === true) {
      if (!hideToast) toast.success("Updated!");
      setEpaySetting({
        ...epaySettings,
        epay: { ...epaySettings?.epay, ...res.data },
      });
      return res.data;
    }
    if (!hideToast) toast.error("Failed to fetch epay settings !");
    return null;
  };

  const enableRecurringPayments = () =>
    updateBusinessEpaySettings(
      { enabled: epaySettings?.epay?.weborder?.enabled },
      true
    );

  const updateAblySettings = async (data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/ablysettings/update`,
      "POST",
      data
    );
    if (res && res.status === true) {
      toast.success("Updated!");
      setEpaySetting({
        ...(epaySettings || {}),
        ably: res.data,
      });
    } else {
      toast.error("Failed to fetch epay settings !");
    }
  };

  const getStripeDashboard = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/epay/dashboard/stripe`
    );
    if (res && res.status === true) {
      setStripeDashboardSettings(res.data);
    } else {
      toast.error("Failed to fetch stripe dashboard settings !");
    }
  };

  const getShortUrl = async (tid, rid, gzsrc) => {
    // const isProduction = process.env.REACT_APP_ENV === "production";
    // const webcode = selectedBusiness?.info?.webcode;

    // if (!tid && !rid) {
    //   return {
    //     url: isProduction
    //       ? `https://appt.cm/~${webcode || ""}`
    //       : `https://appt.cm/~s${webcode || ""}`,
    //   };
    // }
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/servicestaff/shorturl?tid=${
        tid || ""
      }&rid=${rid || ""}${gzsrc ? `&gzsrc=${gzsrc}` : ""}`
    );
    if (res && res.status === true) {
      return res.data;
    }
    return null;
  };

  const getShortUrlGeneral = async (url) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/urlshortner?url=${url}`
    );
    if (res && res.status === true) {
      return res.data;
    }
    return null;
  }

  useEffect(() => {
    setStripeDashboardSettings({});
    setDomains([]);
  }, [selectedBusiness?.id]);

  // useEffect(() => {
  // runWithGuard(getBusinessEpaySettings);
  // runWithGuard(getStripeDashboard);
  // }, [selectedBusiness]);

  return {
    domains,
    epaySettings,
    stripeDashboarSettings,
    updateBusinessEpaySettings,
    updateAblySettings,
    getShortUrl,
    getShortUrlGeneral,
    getStripeDashboard,
    getBusinessEpaySettings,
    updateWhitelistDomain,
    getBusinessDomains,
    domainLoading,
    setDomainLoading,
    isWebOrderEnabled,
    isRecurringEnabled,
    enableRecurringPayments,
  };
};

export default useIntegrationData;
